import React, { useState, useEffect } from 'react';
import { Button, Table, Form, Card } from 'react-bootstrap';
import ExcelExportButton from '../Utils/ExcelExportButton';
import HomeService from '../services/HomeService';
import { useLoading } from '../Utils/LoadingContext';
import PaginationComponent from '../Utils/PaginationComponent';
import './StatusReport.css';
import CustomDatePicker from '../Utils/CustomDatePicker';

const TatReport = () => {
    const today = new Date();
    const { setLoading } = useLoading();
    const [reportData, setReportData] = useState([]);
    const [filters, setFilters] = useState({ lcnumber: '', fromDate: today, toDate: today });

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);

    const tatReportColumns = [
        { label: 'Req Number', key: 'requestNumber' },
        { label: 'Requested On', key: 'requestedOn' },
        { label: 'Subject Line', key: 'title' },
        { label: 'Lc Type', key: 'lcType' },
        { label: 'Approver_1', key: 'approver1' },
        { label: 'Approver_1_TAT_Days', key: 'approver1_TAT_Days' },
        { label: 'Approver_2', key: 'approver2' },
        { label: 'Approver_2_TAT_Days', key: 'approver2_TAT_Days' },
        { label: 'Approver_3', key: 'approver3' },
        { label: 'Approver_3_TAT_Days', key: 'approver3_TAT_Days' },
        { label: 'Approver_4', key: 'approver4' },
        { label: 'Approver_4_TAT_Days', key: 'approver4_TAT_Days' },
        { label: 'Approver_5', key: 'approver5' },
        { label: 'Approver_5_TAT_Days', key: 'approver5_TAT_Days' },
      ];
    const totalPages = Math.ceil(totalRecords / pageSize);
    const fetchData = async (
        page = 1,
        pageSize = 5,
        filterLc = null,
        fromDate = null,
        toDate = null,
        isExport = false // ✅ flag to control whether to return data
    ) => {
        setLoading(true);
        filterLc = filters.lcnumber?.trim() || null;
        fromDate = filters.fromDate ? filters.fromDate.toISOString().split('T')[0] : null;
        toDate = filters.toDate ? filters.toDate.toISOString().split('T')[0] : null;

        if (isExport) {
            pageSize = 0;
        }
        try {
            const response = await HomeService.gettatReport(filterLc, fromDate, toDate, page, pageSize);

            if (response?.success) {
                const mappedData = response.data.result.map((item) => ({
                    requestNumber: item.requestNumber,
                    requestedOn: item.requestedOn,
                    title: item.title,
                    lcType: item.lcType,
                    approver1: item.approver1,
                    approver1_TAT_Days: item.approver1_TAT_Days,
                    approver2: item.approver2,
                    approver2_TAT_Days: item.approver2_TAT_Days,
                    approver3: item.approver3,
                    approver3_TAT_Days: item.approver3_TAT_Days,
                    approver4: item.approver4,
                    approver4_TAT_Days: item.approver4_TAT_Days,
                    approver5: item.approver5,
                    approver5_TAT_Days: item.approver5_TAT_Days,
                }));

                if (isExport) {
                    return mappedData; // ✅ RETURN for ExcelExportButton
                } else {
                    setReportData(mappedData);
                    setTotalRecords(response.data.result[0]?.totalCount || 0);
                }
            } else {
                if (!isExport) {
                    setReportData([]);
                    setTotalRecords(0);
                }
                return [];
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            return [];
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchData(currentPage, pageSize);

    }, [currentPage]);

    const handleBeforeExport = async () => {

        const filterLc = filters.lcnumber?.trim() || null;
        const fromDate = filters.fromDate ? filters.fromDate.toISOString().split('T')[0] : null;
        const toDate = filters.toDate ? filters.toDate.toISOString().split('T')[0] : null;

        setCurrentPage(1);

        const exportData = await fetchData(1, 0, filterLc, fromDate, toDate, true); // pass true for Excel export

        return exportData; // ExcelExportButton will receive this
    };

    const handleFilter = () => {

        const filterLc = filters.lcnumber.trim() === '' ? null : filters.lcnumber.trim();
        const fromDate = filters.fromDate ? filters.fromDate.toISOString().split('T')[0] : null;
        const toDate = filters.toDate ? filters.toDate.toISOString().split('T')[0] : null;
        setCurrentPage(1);
        fetchData(1, pageSize, filterLc, fromDate, toDate);
    };

    return (
        <div className="container ">
            <div className="request-form">
                <h6 className="fw-bold text-primary mb-2">Tat Report</h6>
                {/* Filter Section */}
                <Card className="mb-2 shadow-sm">
                    <Card.Body>
                        <Form>
                            <div className="row g-3 align-items-end">

                                {/* Request Number */}
                                <div className="col-md-3">
                                    <Form.Group controlId="filterLcNumber" className="filter-item">
                                        <Form.Label className="small">Request Number</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            placeholder="Filter by Request Number"
                                            value={filters.lcnumber}
                                            onChange={(e) => setFilters({ ...filters, lcnumber: e.target.value })}
                                        />
                                    </Form.Group>
                                </div>

                                {/* From Date */}
                                <div className="col-md-3">
                                    <Form.Group controlId="fromDate" className="filter-item">
                                        <Form.Label className="small">From Date</Form.Label>
                                        <div className="form-control-sm p-0">
                                            <CustomDatePicker
                                                selectedDate={filters.fromDate}
                                                onChange={(date) => setFilters({ ...filters, fromDate: date })}

                                            />
                                        </div>
                                    </Form.Group>
                                </div>

                                {/* To Date */}
                                <div className="col-md-3">
                                    <Form.Group controlId="toDate" className="filter-item">
                                        <Form.Label className="small">To Date</Form.Label>
                                        <div className="form-control-sm p-0">
                                            <CustomDatePicker
                                                selectedDate={filters.toDate}
                                                onChange={(date) => setFilters({ ...filters, toDate: date })}
                                            />
                                        </div>
                                    </Form.Group>
                                </div>

                                {/* Apply Filter Button */}
                                <div className="col-md-3 d-grid">
                                    <Button variant="primary" size="sm" className="h-100" onClick={handleFilter}>
                                        Apply Filters
                                    </Button>
                                </div>

                            </div>
                        </Form>
                    </Card.Body>
                </Card>




                <div className="d-flex align-items-center justify-content-end mb-2 gap-2">
                        <h6 className="fw-bold text-black m-0">
                            Total Records: {totalRecords}
                        </h6>
                        {totalRecords > 0 && (
                            <ExcelExportButton
                                onBeforeExport={handleBeforeExport}
                                fileName="TatReport.xlsx"
                                className="btn btn-sm btn-success"
                                columns={tatReportColumns}
                            />
                        )}
                    </div>
                {/* Table Section */}
                <div className="table-responsive mt-2">
                    


                    <Table bordered hover className="align-middle shadow-sm">
                        <thead className="table-light">
                            <tr>
                                <th>Sr No</th>
                                <th>Req Number</th>
                                <th>Subject Line</th>
                                <th>Requested On</th>
                                <th>Lc Type</th>
                                <th>Approver_1</th>
                                <th>Approver_1_Tat_Days</th>
                                <th>Approver_2</th>
                                <th>Approver_2_Tat_Days</th>
                                <th>Approver_3</th>
                                <th>Approver_3_Tat_Days</th>
                                <th>Approver_4</th>
                                <th>Approver_4_Tat_Days</th>
                                <th>Approver_5</th>
                                <th>Approver_5_Tat_Days</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportData.length > 0 ? (
                                reportData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                        <td>{item.requestNumber}</td>
                                        <td>{item.title}</td>
                                        <td>{item.requestedOn}</td>
                                        <td>{item.lcType}</td>
                                        <td>{item.approver1}</td>
                                        <td>{item.approver1_TAT_Days}</td>
                                        <td>{item.approver2}</td>
                                        <td>{item.approver2_TAT_Days}</td>
                                        <td>{item.approver3}</td>
                                        <td>{item.approver3_TAT_Days}</td>
                                        <td>{item.approver4}</td>
                                        <td>{item.approver4_TAT_Days}</td>
                                        <td>{item.approver5}</td>
                                        <td>{item.approver5_TAT_Days}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="15" className="text-center text-muted" >No record found.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                    <PaginationComponent
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />
                )}



            </div>
        </div>
    );
};

export default TatReport;
